import * as React from 'react'

import OptionsHeader from '~/client/src/shared/components/OptionsList/pieces/OptionsHeader'

export interface IDrillDownFilterHeaderProps {
  title: string
  showBackButton: boolean
  onBack: () => void
  onCancel: () => void
}

export default function DrillDownFilterHeader({
  title,
  showBackButton,
  onBack,
  onCancel,
}: IDrillDownFilterHeaderProps) {
  return (
    <OptionsHeader
      title={title}
      onBack={showBackButton ? onBack : undefined}
      onClose={onCancel}
    />
  )
}
